import kebabCase from "lodash/kebabCase";

const buildPathName = (basePath, analyticsNameEventMap, elements) => {
  let pathname = `${basePath}`;
  elements.forEach(el => {
    if (analyticsNameEventMap[el]) {
      pathname += `:${analyticsNameEventMap[el]}`;
    } else {
      pathname += `:${kebabCase(el).replace(/-/g, " ").toLowerCase()}`;
    }
  });
  return pathname;
};

export default buildPathName;
